import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { saveWeightGoal } from '../../../store/ducks/user';
import SettingsContainer from '../../../components/settings-container';
import SingleSelect from '../../../components/single-select';
import { weightGoalOptionsMetric, weightGoalOptionsStandard } from './weight-goal-options';

class WeightLossGoalPage extends Component {
  constructor(props) {
    super(props);
    const weightGoalOptions = props.units === 'metric' ? weightGoalOptionsMetric : weightGoalOptionsStandard;
    this.state = { pageData: weightGoalOptions, weightGoal: this.props.initialValue };
  }

  save = async () => {
    try {
      await this.props.saveWeightGoal(this.state.weightGoal);
    } catch (e) {
      /* do nothing */
    }
  }

  onSelect = (selectOption) => {
    const weightGoal = selectOption === null ? '' : this.state.pageData.selectOptions[selectOption].value;
    this.setState({ weightGoal });
  }

  getInitialValue = () => {
    return this.state.pageData.selectOptions.findIndex(({ value }) => value === this.props.initialValue);
  }

  render() {
    return (
      <SettingsContainer
        className="weekly-weight-loss-goal"
        pageTitle={ this.state.pageData.title }
        save={ this.save }
        isValid={ Boolean(this.state.weightGoal) }
      >
        <SingleSelect selectOptions={ this.state.pageData.selectOptions } onSelect={ this.onSelect } value={ this.getInitialValue() } />
      </SettingsContainer>
    );
  }
}

WeightLossGoalPage.propTypes = {
  initialValue: PropTypes.number,
  saveWeightGoal: PropTypes.func.isRequired,
  units: PropTypes.string,
};

export default connect(
  state => ({
    initialValue: state.user.target_weight_change,
    units: state.user.units
  }),
  dispatch => ({
    saveWeightGoal: weightGoal => dispatch(saveWeightGoal(weightGoal))
  }),
  null,
  {
    withRef: true
  }
)(WeightLossGoalPage);
